import { couponRequestOptions, getExplicitCoupon, syncExplicitCoupon } from './couponSession';

export const LOGIN_CART_RECEIVED = '[Shop] Login cart received';
export const LOGIN_CART_REVIEWED = '[Shop] Login cart reviewed';

export const loginCartContext = state => {
    const coupon = state.shop.cart.coupon;
    const name = getExplicitCoupon();
    return {
        ...couponRequestOptions(), coupon_name: name,
        accept_btl: Boolean(name && coupon?.name === name && coupon.source === 'btl'),
        shipping_method_id: state.shop.shipping.methods.selected?._id || ''
    };
};

export const receiveLoginCart = cart => {
    syncExplicitCoupon(cart.coupon, getExplicitCoupon());
    return { type: LOGIN_CART_RECEIVED, payload: cart };
};

export const reviewLoginCart = () => ({ type: LOGIN_CART_REVIEWED });
